import $ from 'jquery';
import 'regenerator-runtime';

window['$'] = window['jQuery'] = $;
